export enum EducationLevel {
  none = 'None',
  academy = 'Academy Profession',
  bachelor = 'Bachelor',
  master = 'Master',
  phd = 'Ph.D',
  other = 'Other'
}
